import { getMfhElements, saveMfhElements, updateMfhElement, deleteMfhElements } from '@/api/mfh';
import type { IMFHElement, MFHElementExpandOpts, MFHElementType } from '@condo/domain';
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import type { MaybeRef } from 'vue';
import { unref } from 'vue';

export const useMfhElements = (mfhId: MaybeRef<number>, params?: MaybeRef<{ type?: MFHElementType[]; expand?: MFHElementExpandOpts }>) => {
    return useQuery(['mfh-elements', 'mfhId', mfhId, params], async () => getMfhElements(unref(mfhId), unref(params)), {
        initialData: [],
    });
};

export const useMfhElementMutations = () => {
    const queryClient = useQueryClient();

    const saveMfhElementsMutation = useMutation({
        mutationFn: async ({ mfhId, elements }: { mfhId: number; elements: Partial<IMFHElement>[] }) => {
            return saveMfhElements(mfhId, elements);
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['mfh-elements', 'mfhId', variables.mfhId] });
        },
    });

    const updateMfhElementMutation = useMutation({
        mutationFn: async ({ mfhElementId, data }: { mfhElementId: number; data: Partial<IMFHElement> }) => {
            return updateMfhElement(mfhElementId, data);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['mfh-elements'] });
        },
    });

    const deleteMfhElementsMutation = useMutation({
        mutationFn: async ({ mfhElementIds }: { mfhElementIds: number[] }) => {
            return deleteMfhElements(mfhElementIds);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['mfh-elements'] });
        },
    });

    return {
        saveMfhElementsMutation,
        updateMfhElementMutation,
        deleteMfhElementsMutation,
    };
};
